import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminIndex: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // /admin 접근시 자동으로 /admin/dashboard로 리다이렉트
    navigate('/admin/dashboard', { replace: true });
  }, [navigate]);

  return null; // 리다이렉트 중이므로 아무것도 렌더링하지 않음
};

export default AdminIndex;
